import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { Button } from "@/components/ui/button";
import { loadAnalytics } from "@/lib/analytics";

const KEY = "cookie_consent";

export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try { if (!localStorage.getItem(KEY)) setShow(true); } catch { setShow(true); }
  }, []);

  const accept = () => {
    try { localStorage.setItem(KEY, "accepted"); } catch { /* storage blocked */ }
    setShow(false);
    loadAnalytics();
  };

  const reject = () => {
    try { localStorage.setItem(KEY, "rejected"); } catch { /* storage blocked */ }
    setShow(false);
  };

  if (!show) return null;
  return (
    <div className="fixed inset-x-3 bottom-3 z-[100] mx-auto max-w-3xl rounded-xl border border-border bg-card/95 p-4 shadow-2xl backdrop-blur-xl sm:inset-x-6" data-testid="cookie-consent">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
        <Cookie className="h-6 w-6 shrink-0 text-primary" />
        <p className="flex-1 text-sm text-muted-foreground">
          Používame nevyhnutné cookies na udržanie prihlásenia a – po vašom súhlase – analytické cookies (Google Analytics, Meta) na meranie návštevnosti a zlepšovanie služby. Viac v dokumente{" "}
          <Link to="/ochrana-osobnych-udajov" className="text-primary underline" data-testid="cookie-privacy-link">Ochrana osobných údajov</Link>.
        </p>
        <div className="flex gap-2">
          <Button variant="outline" onClick={reject} className="min-h-[44px] whitespace-nowrap" data-testid="cookie-reject">Odmietnuť</Button>
          <Button onClick={accept} className="min-h-[44px] whitespace-nowrap" data-testid="cookie-accept">Prijať všetko</Button>
        </div>
      </div>
    </div>
  );
}
